module.exports = __webpack_public_path__ + "img/bar.9dec7801.png";